module.exports = __webpack_public_path__ + "img/vanilla_refund_banner.7b68f612.svg";